"use client"

import * as React from "react"
import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react"
import { cn } from "cn"

import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from "./input-group"

function SearchBar({ className, ...props }: React.ComponentProps<typeof InputGroup>) {
  return (
    <InputGroup
      data-search-bar=""
      className={cn(
        "h-10 rounded-full border-border bg-card px-1 shadow-xs has-[[data-slot=input-group-control]:focus-visible]:border-primary",
        className
      )}
      {...props}
    />
  )
}

function SearchBarIcon({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <InputGroupAddon className={cn("ps-3 text-muted-foreground", className)} {...props}>
      <MagnifyingGlassIcon className="size-[18px]" aria-hidden="true" />
    </InputGroupAddon>
  )
}

const SearchBarInput = React.forwardRef<HTMLInputElement, React.ComponentProps<typeof InputGroupInput>>(
  function SearchBarInput({ className, ...props }, ref) {
  return (
    <InputGroupInput
      ref={ref}
      type="search"
      className={cn(
        "typo-body-sm h-full [&::-webkit-search-cancel-button]:appearance-none",
        className
      )}
      {...props}
    />
  )
})

function SearchBarClear({
  className,
  ...props
}: React.ComponentProps<typeof InputGroupButton> & { "aria-label": string }) {
  return (
    <InputGroupButton
      size="icon-xs"
      className={cn("rounded-full text-muted-foreground", className)}
      {...props}
    >
      <XIcon />
    </InputGroupButton>
  )
}

function SearchBarActions({ className, ...props }: React.ComponentProps<"div">) {
  return <InputGroupAddon align="inline-end" className={cn("gap-1 pe-1", className)} {...props} />
}

export { SearchBar, SearchBarIcon, SearchBarInput, SearchBarClear, SearchBarActions }
